exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col-xs-5ths,\n.col-sm-5ths,\n.col-md-5ths,\n.col-lg-5ths {\n  position: relative;\n  min-height: 1px;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.col-xs-5ths {\n  width: 20%;\n  float: left;\n}\n\n@media (min-width: 768px) {\n  .col-sm-5ths {\n    width: 20%;\n    float: left;\n  }\n}\n\n@media (min-width: 992px) {\n  .col-md-5ths {\n    width: 20%;\n    float: left;\n  }\n}\n\n@media (min-width: 1200px) {\n  .col-lg-5ths {\n    width: 20%;\n    float: left;\n  }\n}", ""]);

// exports
